<script>
export default {
  name: "account",
};
</script>

<template>
  <div>account</div>
</template>
